import { axInst } from "../Login/Service.jsx";

//region
export const fetchRegion = async () => {
  const { data } = await axInst.post("powerdeck/filter", {
    region: [],
    state: [],
    state_office: [],
    Product_Line: [],
    lob: [],
  });

  const regionsArray = data?.REGION.buckets.map((e) => e.key);
  const sortedRegionArray = regionsArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );
  return sortedRegionArray;
};

//state
export const fetchStates = async (pRegion) => {
  const { data } = await axInst.post("powerdeck/filter", {
    region: pRegion || [],
    state: [],
    state_office: [],
    Product_Line: [],
    lob: [],
  });
  const statesArray = data?.STATE.buckets.map((e) => e.key);
  const sortedStatesArray = statesArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedStatesArray;
};

//stateoffice
export const fetchStatesOffice = async (pRegion, pState) => {
  const { data } = await axInst.post("powerdeck/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: [],

    Product_Line: [],
    lob: [],
  });
  const statesOfficeArray = data?.STATE_OFFICE.buckets.map((e) => e.key);
  const sortedStatesOfficeArray = statesOfficeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedStatesOfficeArray;
};

export const fetchProductLine = async (pRegion, pState, pStateOffice) => {
  const { data } = await axInst.post("powerdeck/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],

    Product_Line: [],
    lob: [],
  });
  const productLineArray = data?.PRODUCT_LINE.buckets.map((e) => e.key);

  const sortedProductLineArray = productLineArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );
  return sortedProductLineArray;
};

//Lob
export const fetchLOB = async (
  pRegion,
  pState,
  pStateOffice,

  pProductLine,
) => {
  const { data } = await axInst.post("powerdeck/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],

    Product_Line: pProductLine || [],
    lob: [],
  });

  const lobArray = data?.LOB.buckets.map((e) => e.key);
  const sortedLobArray = lobArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedLobArray;
};
